/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { ProjectFindingsDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Project
 */
export const getIntelligenceFindingsProjectProjectId = (
  projectId: number,
  signal?: AbortSignal,
) => {
  return customInstance<ProjectFindingsDto>({
    url: `/intelligence/findings/project/${projectId}`,
    method: "GET",
    signal,
  });
};

export const getGetIntelligenceFindingsProjectProjectIdInfiniteQueryKey = (
  projectId?: number,
) => {
  return ["infinite", `/intelligence/findings/project/${projectId}`] as const;
};

export const getGetIntelligenceFindingsProjectProjectIdQueryKey = (
  projectId?: number,
) => {
  return [`/intelligence/findings/project/${projectId}`] as const;
};

export const getGetIntelligenceFindingsProjectProjectIdInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntelligenceFindingsProjectProjectIdInfiniteQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>
  > = ({ signal }) =>
    getIntelligenceFindingsProjectProjectId(projectId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceFindingsProjectProjectIdInfiniteQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>
  >;
export type GetIntelligenceFindingsProjectProjectIdInfiniteQueryError = void;

export function useGetIntelligenceFindingsProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceFindingsProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceFindingsProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Project
 */

export function useGetIntelligenceFindingsProjectProjectIdInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>
  >,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetIntelligenceFindingsProjectProjectIdInfiniteQueryOptions(
      projectId,
      options,
    );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetIntelligenceFindingsProjectProjectIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetIntelligenceFindingsProjectProjectIdQueryKey(projectId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>
  > = ({ signal }) =>
    getIntelligenceFindingsProjectProjectId(projectId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!projectId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIntelligenceFindingsProjectProjectIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>
>;
export type GetIntelligenceFindingsProjectProjectIdQueryError = void;

export function useGetIntelligenceFindingsProjectProjectId<
  TData = Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceFindingsProjectProjectId<
  TData = Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
          TError,
          Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetIntelligenceFindingsProjectProjectId<
  TData = Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Project
 */

export function useGetIntelligenceFindingsProjectProjectId<
  TData = Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
  TError = void,
>(
  projectId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getIntelligenceFindingsProjectProjectId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetIntelligenceFindingsProjectProjectIdQueryOptions(
    projectId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
